<template>
  <b-card>

    <!-- form -->
    <b-form class="mt-2">
      <b-row>
        <b-col sm="6">
          <b-form-group
            label="Nombre"
            label-for="account-name"
          >
            <b-form-input
              v-model="userData.name"
              name="name"
              placeholder="Nombre"
            />
          </b-form-group>
        </b-col>
        <b-col sm="6">
          <b-form-group
            label="Correo electrónico"
            label-for="account-e-mail"
          >
            <b-form-input
              v-model="userData.email"
              name="email"
              placeholder="Correo electrónico"
            />

          </b-form-group>
        </b-col>

        <b-col sm="6">
          <b-form-group
            label="Rol"
            label-for="role"
          >
            <b-form-input
              v-model="role"
              name="role"
              placeholder="Rol"
            />

          </b-form-group>
        </b-col>

        <b-col sm="6">
          <b-form-group
            label="Autenticación"
            label-for="authType"
          >
            <b-form-input
              v-model="authType"
              name="authType"
              placeholder="Autenticación"
            />

          </b-form-group>
        </b-col>
      </b-row>
    </b-form>
  </b-card>
</template>

<script>
import {
  BForm, BFormGroup, BFormInput, BRow, BCol, BCard,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref } from '@vue/composition-api'

export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
  },
  directives: {
    Ripple,
  },
  props: {
    userData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      profileFile: null,
      roles: [
        { value: 'admin', label: 'Administrador' },
        { value: 'user', label: 'Usuario' },
        { value: 'tech', label: 'Técnico' },
      ],
      authTypes: [
        { value: 'system', label: 'Sistema' },
        { value: 'microsoft', label: 'Microsoft' },
      ],
    }
  },
  computed: {
    role: {
      get() {
        return this.roles.find(role => role.value === this.userData.role).label
      },
    },
    authType: {
      get() {
        return this.authTypes.find(authType => authType.value === this.userData.authType).label
        //return 'Microsoft'
      },
    },
  },
  mounted() {
    console.log('====================================')
    console.log(this.userData)
    console.log('====================================')
  },
  methods: {
    resetForm() {
      // this.optionsLocal = JSON.parse(JSON.stringify(this.generalData))
    },
  },
  setup() {
    const refInputEl = ref(null)
    const previewEl = ref(null)

    return {
      refInputEl,
      previewEl,
    }
  },
}
</script>
